import { css } from 'styled-components'
import type { TypographyVariant } from '../tokens/typography'

export const textStyle = (variant: TypographyVariant) => css`
  font-family: ${({ theme }) => theme.typography.family.base};
  font-size: ${({ theme }) => theme.typography.variants[variant].fontSize};
  line-height: ${({ theme }) => theme.typography.variants[variant].lineHeight};
  font-weight: ${({ theme }) => theme.typography.variants[variant].fontWeight};
  letter-spacing: ${({ theme }) => theme.typography.variants[variant].letterSpacing};
`
